import { createFileRoute } from '@tanstack/react-router'
import { ApiKeysPage } from '@/pages/api-keys'

export const Route = createFileRoute('/_authenticated/ai/api-keys')({
  staticData: { title: 'API Keys' },
  component: ApiKeysPage,
})
